module.exports = __webpack_public_path__ + "static/img/3.0ab6bf5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/theme/light/desc/02keepAlive/meizu/3.png
// module id = zNE2
// module chunks = 0